import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { getGoodsByIdSagaAction, getGoodsSagaAction, removeGoodsSagaAction } from "../../redux/sagaActions";

const GoodsList = () => {
    const dispatch = useDispatch();

    const goods = useSelector(state => state.goods);
    const currentEstablishment = useSelector(state => state.currentEstablishment);

    // Получение списка товаров
    useEffect(() => {
        if (!currentEstablishment) return;

        dispatch(getGoodsSagaAction());
    }, [currentEstablishment]);

    return (
        <div className="settings">
            {
                goods.map(elem => {
                    return (
                        <div className="setting" key={ elem.id }>
                            <div className="controls">
                                <i
                                    className="control control--edit"
                                    onClick={ () => dispatch(getGoodsByIdSagaAction({ id: elem.id })) }
                                />
                                {/*<i className="control control--move" />*/}
                                <i className="control control--remove" onClick={ () => {
                                    if (window.confirm('Вы действительно хотите удалить этот товар?')) {
                                        dispatch(removeGoodsSagaAction({ id: elem.id }));
                                    }
                                } }/>
                            </div>
                            <div className="setting__caption">{ elem.name }</div>
                        </div>
                    );
                })
            }
        </div>
    );
};

export default GoodsList;